var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentMethod = function SvgPaymentMethod(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 23,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    stroke: "#D0D5DD",
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8F97AA",
    d: "M26.666 7.417v9.166q0 .828-.6 1.435t-1.441.607h-13.25q-.828 0-1.435-.607a1.96 1.96 0 0 1-.607-1.435V7.417q0-.828.607-1.435a1.96 1.96 0 0 1 1.435-.607h13.25q.842 0 1.442.607t.6 1.435M11.375 8.542h13.25V7.417h-13.25zm0 3.875v4.166h13.25v-4.166z"
  })));
};
export default SvgPaymentMethod;